<template>
  <div class="c-tabs">
    <ul>
      <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          @click="routeTo(0)"
          :class="[
            'tab-anchor',
            {
              'is-active': props.tabIndex === 0,
            },
          ]"
          role="tab"
          aria-selected
        >
          회원정보관리
        </a>
      </li>
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          @click="routeTo(1)"
          :class="[
            'tab-anchor',
            {
              'is-active': props.tabIndex === 1,
            },
          ]"
          role="tab"
        >
          배송지관리
        </a>
      </li>
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          @click="routeTo(2)"
          :class="[
            'tab-anchor',
            {
              'is-active': props.tabIndex === 2,
            },
          ]"
          role="tab"
        >
          조색기관리
        </a>
      </li>
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          @click="routeTo(3)"
          :class="[
            'tab-anchor',
            {
              'is-active': props.tabIndex === 3,
            },
          ]"
          role="tab"
        >
          문의내역
        </a>
      </li>
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          @click="routeTo(4)"
          :class="[
            'tab-anchor',
            {
              'is-active': props.tabIndex === 4,
            },
          ]"
          role="tab"
        >
          마일리지내역
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onMounted, defineProps } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  tabIndex: {
    type: Number,
    required: true,
  },
});

onMounted(() => {});

const routeTo = (tabIndex) => {
  const menus = [
    { index: 0, path: "/paintpro/utility/memberInfo" },
    { index: 1, path: "/paintpro/utility/delivMng" },
    { index: 2, path: "/paintpro/utility/colorMng" },
    { index: 3, path: "/paintpro/utility/inquireList" },
    { index: 4, path: "/paintpro/utility/mileageMng" },
  ];

  const selectedMenu = menus.find((menu) => menu.index === tabIndex);
  if (!selectedMenu) {
    console.warn(`Tab Menu Not found. (tabIndex: ${tabIndex})`);
    return;
  }
  router.push({
    path: selectedMenu.path,
  });
};
</script>
<style scoped></style>
